var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ProofDeliveryHistory", attrs: { fluid: "" } },
    [
      _c("PaginationController", {
        ref: "paginate",
        attrs: {
          getDataActionName: "getProofDeliveryHistory",
          historyLimit: _vm.historyLimit,
          select: _vm.hazmatWarehouseSite,
          haveStartDate: "",
          isStartWithoutData: ""
        },
        scopedSlots: _vm._u([
          {
            key: "dataTable",
            fn: function() {
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.histories,
                    "hide-actions": "",
                    "item-key": "orderId"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.index + 1) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("LabelDetailsWidget", {
                                attrs: {
                                  shipmentLabel: props.item,
                                  index: props.index
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("LabelAddressWidget", {
                                attrs: { address: props.item.from }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("LabelAddressWidget", {
                                attrs: { address: props.item.to }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$store.getters.activeWarehouse
                            ? _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.organizationKeyToId.get(
                                        props.item.clientKey
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              props.item.status !== "failed"
                                ? _c("LabelTrackingDetailWidget", {
                                    attrs: {
                                      trackingNumber: props.item.trackingNumber,
                                      status: props.item.status,
                                      carrier: props.item.carrier,
                                      details: props.item.trackingDetails
                                    }
                                  })
                                : _c(
                                    "div",
                                    _vm._l(props.item.messages, function(
                                      messageItem
                                    ) {
                                      return _c(
                                        "p",
                                        { key: messageItem.time },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(messageItem.message) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              props.item.carrier
                                ? _c("v-layout", [
                                    _c("strong", [
                                      _vm._v(_vm._s(props.item.carrier))
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-layout", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.serviceDescription) +
                                    "\n            "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            dark: "",
                                            flat: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.downloadFile(
                                                props.item.filePathDownloadURL
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("export")))]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedLabels,
                    callback: function($$v) {
                      _vm.selectedLabels = $$v
                    },
                    expression: "selectedLabels"
                  }
                })
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.histories,
          callback: function($$v) {
            _vm.histories = $$v
          },
          expression: "histories"
        }
      }),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        ref: "form",
        attrs: {
          title: "OP950",
          rightMethod: _vm.exportOp950Doc,
          rightButtonText: _vm.$t("create"),
          rightButtonLoading: _vm.op950Modal.loading,
          leftMethod: function() {
            return (_vm.op950Modal.show = false)
          },
          hasAlert: "",
          medium: ""
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  {
                    attrs: { "justify-space-between": "", "align-baseline": "" }
                  },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md4: "" } },
                      [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "close-on-content-click": false,
                              transition: "scale-transition",
                              "offset-y": "",
                              "nudge-right": 40,
                              lazy: "",
                              "full-width": "",
                              "min-width": "290px"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              label: _vm.$t("closeDate"),
                                              "prepend-icon": "mdi-calendar",
                                              readonly: ""
                                            },
                                            model: {
                                              value: _vm.op950Modal.closeDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.op950Modal,
                                                  "closeDate",
                                                  $$v
                                                )
                                              },
                                              expression: "op950Modal.closeDate"
                                            }
                                          },
                                          "v-text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.showDatePick,
                              callback: function($$v) {
                                _vm.showDatePick = $$v
                              },
                              expression: "showDatePick"
                            }
                          },
                          [
                            _vm._v(" "),
                            _c("v-date-picker", {
                              on: {
                                input: function($event) {
                                  _vm.showDatePick = false
                                }
                              },
                              model: {
                                value: _vm.op950Modal.closeDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.op950Modal, "closeDate", $$v)
                                },
                                expression: "op950Modal.closeDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md5: "" } },
                      [
                        _c("v-select", {
                          staticStyle: { transform: "translateY(5px)" },
                          attrs: {
                            items: _vm.hazmatSitesOptions,
                            label: _vm.$t("warehouseSite")
                          },
                          model: {
                            value: _vm.op950Modal.hazmatWarehouseSite,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.op950Modal,
                                "hazmatWarehouseSite",
                                $$v
                              )
                            },
                            expression: "op950Modal.hazmatWarehouseSite"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { md1: "" } })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.op950Modal.show,
          callback: function($$v) {
            _vm.$set(_vm.op950Modal, "show", $$v)
          },
          expression: "op950Modal.show"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8bd4db68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bd4db68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProofDeliveryHistory.vue
// module id = null
// module chunks = 